module.exports = __webpack_public_path__ + "img/facebook.be321bd7.svg";